import { Button, Form, Input, InputNumber, Modal, Popconfirm } from "antd";
import React, { useEffect, useState } from "react";
import type { VolunteerSubject } from "../types";
import type { VolunteerStore } from "../store";

interface Props {
  store: VolunteerStore;
  subject?: VolunteerSubject;
  open: boolean;
  onClose: () => void;
}

export const SubjectFormModal = ({ store, subject, open, onClose }: Props) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        title: subject?.title ?? "",
        order: subject?.order ?? 0,
      });
    }
  }, [open, subject, form]);

  const handleOk = async () => {
    const values = await form.validateFields();
    setSubmitting(true);
    try {
      if (subject?.objectId) {
        await store.updateSubject(subject.objectId, {
          title: values.title,
          order: values.order,
        });
      } else {
        await store.createSubject({
          title: values.title,
          order: values.order,
        });
      }
      form.resetFields();
      onClose();
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async () => {
    if (!subject?.objectId) return;
    await store.deleteSubject(subject.objectId);
    onClose();
  };

  return (
    <Modal
      open={open}
      title={subject ? "Thema bearbeiten" : "Neues Thema"}
      okText={subject ? "Speichern" : "Anlegen"}
      cancelText="Abbrechen"
      confirmLoading={submitting}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      footer={(_, { OkBtn, CancelBtn }) => (
        <>
          {subject && (
            <Popconfirm
              title="Thema wirklich löschen?"
              description="Aufgaben ohne Thema bleiben erhalten und werden als 'Ohne Thema' angezeigt."
              onConfirm={handleDelete}
              okText="Ja"
              cancelText="Nein"
            >
              <Button danger style={{ float: "left" }}>
                Löschen
              </Button>
            </Popconfirm>
          )}
          <CancelBtn />
          <OkBtn />
        </>
      )}
    >
      <Form form={form} layout="vertical" initialValues={{ order: 0 }}>
        <Form.Item
          name="title"
          label="Titel"
          rules={[{ required: true, message: "Bitte Titel eingeben" }]}
        >
          <Input placeholder="z.B. Küche, Bar, Auf-/Abbau" />
        </Form.Item>
        <Form.Item name="order" label="Reihenfolge">
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
